module.exports = __webpack_public_path__ + "imgs/promocode1@1x-min.a4a198e8.webp";